export default "<p>ssoreturn works!</p>\n"